import { render } from "./AvioFox.vue?vue&type=template&id=231fead6&scoped=true"
import script from "./AvioFox.vue?vue&type=script&lang=js"
export * from "./AvioFox.vue?vue&type=script&lang=js"

import "./AvioFox.vue?vue&type=style&index=0&id=231fead6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231fead6"]])

export default __exports__